import { render, staticRenderFns } from "./HeaderComponent.vue.vue?vue&type=template&id=65d253be&scoped=true&"
import script from "./HeaderComponent.vue.vue?vue&type=script&lang=js&"
export * from "./HeaderComponent.vue.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComponent.vue.vue?vue&type=style&index=0&id=65d253be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d253be",
  null
  
)

export default component.exports